import { ChangeDetectorRef, Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ConnectRelationshipDialogComponent } from '@app/shared/component/connect-relationship-dialog/connect-relationship-dialog.component';
import { UserInviteComponent } from '@app/shared/component/user-invite/user-invite.component';
import { UserConnectionService, UserService } from '@app/shared/services';
import { environment } from '@env/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { select, Store } from '@ngrx/store';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import * as loginSelectors from '../../../root-store/login-store/login.selector';

import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
@AutoUnsubscribe()
@Component({
  selector: 'profile-left-sidebar',
  templateUrl: './profile-left-sidebar.component.html',
  styleUrls: ['./profile-left-sidebar.component.scss'],
})
export class ProfileLeftSideBarComponent implements OnInit, OnDestroy {
  @Output() public onConnectionFilter: EventEmitter<any> = new EventEmitter();

  @ViewChild('inviteFormDirective', { static: true })
  inviteForm: UntypedFormGroup;
  url: string;
  user: any = {};
  pendingConnectionCount: number;
  connectionsCount: number;
  suggestionsData: Array<any> = [];
  suggestionsCount: number;
  inviteModalReference: any;
  other_user_id: any;
  defaultprofileUrl;
  subscription: Subscription = new Subscription();

  constructor(
    private router: Router,
    private userConnectionService: UserConnectionService,
    private userService: UserService,
    private cd: ChangeDetectorRef,
    private _fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private toastr: ToastrService,
    public activatedRoute: ActivatedRoute,
    private _store: Store
  ) {
    this.subscription.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.url = event.url;
        }
      })
    );
  }

  openInviteFriend() {
    this.inviteModalReference = this.modalService.open(UserInviteComponent);
  }

  ngOnInit() {
    this.defaultprofileUrl = environment.baseUrl + '/assets/images/dummy-user.jpg';
    let param_id = this.activatedRoute.snapshot.paramMap.get('id');

    if (param_id != undefined) {
      if (param_id) {
        this.other_user_id = param_id;
        this.getOtherProfile();
      } else {
        this.getAuthProfile();
      }
    } else {
      this.getAuthProfile();
    }

    this.inviteForm = this._fb.group({
      inviteEmail: ['', [Validators.required, Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,25}$')]],
    });

    this.getConnections();
    this.suggestions();
    this.cd.markForCheck();
  }

  getOtherProfile() {
    // this.subscription.add(
    //   this.userService.getOtherUser({ user_id: this.other_user_id }).subscribe((data) => {
    //     this.user = data;
    //   })
    // );
  }

  getAuthProfile() {
    this.subscription.add(
      this._store.pipe(select(loginSelectors.getCurrentUserFullDetails)).subscribe((data) => {
        if (data) {
          this.user = data;
        } else {
          this.user = null;
        }
      })
    );
  }

  getConnections() {
    this.subscription.add(
      this.userConnectionService.getConnections().subscribe(
        (data: any) => {
          this.cd.markForCheck();
          this.pendingConnectionCount = data.filter((c) => c.connection_status == 'pending').length;
          this.connectionsCount = data.length - this.pendingConnectionCount;
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  updateConnectionStatus(params) {
    this.subscription.add(
      this.userConnectionService.userConnectionUpdate(params).subscribe(
        (data: any) => {
          this.getConnections();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  suggestions() {
    this.subscription.add(
      this.userConnectionService.getSuggestions({ limit: 2 }).subscribe(
        (data: any) => {
          this.suggestionsData = data.suggestions;
          this.suggestionsCount = data.total_count;
          this.cd.markForCheck();
        },
        (error: any) => {
          this.toastr.error(error.error.message);
        }
      )
    );
  }

  openConnectModal(params) {
    let user = {
      user_profile_image_url: params.user_profile_image_url ? params.user_profile_image_url : params.profile_image_url,
      user_first_middle_name: params.user_first_middle_name ? params.user_first_middle_name : params.first_name,
      user_last_name: params.user_last_name ? params.user_last_name : params.last_name,
      user_id: params.user_id ? params.user_id : params.id,
    };
    const modalRef = this.modalService.open(ConnectRelationshipDialogComponent);
    modalRef.componentInstance.data = { user: user };
    modalRef.result.then((response) => {
      if (response.id) {
        this.user.user_connections = response;
        this.cd.markForCheck();
        this.suggestions();
      }
    });
  }

  initiateConnectionFilter(filterVal) {
    this.onConnectionFilter.emit(filterVal);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
